import React, { useRef } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { UploadedFile } from '@features/AdminConversationUsersSearchForm/ui/UploadedFile';
import { DnD } from '@shared/ui';

import cls from './MassForm.module.css';

interface MassFormProps {
    classes?: string;
    file: (TAttachmentOnClient | TAttachmentDTOCamelCased)[];
    uploadFilesHandler: (files: File[]) => void;
}

export const MassForm = ({ classes, file, uploadFilesHandler }: MassFormProps) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const onClickInputRef = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className={cn(cls.MassForm, [classes])}>
            <DnD<TAttachmentOnClient | TAttachmentDTOCamelCased>
                attachmentsData={file}
                multiple={false}
                onUploadHandler={uploadFilesHandler}
                fileInputRef={fileInputRef}
                containerClassName={cls.dnd}
                accept=".xls,.xlsx,.csv"
                addFileTitle={t('NewsletterStep.return.CustomModal.Body.DnD.addFileTitle')}
                renderAttachmentsList={() => (
                    <UploadedFile file={file[0]} onClickInputRef={onClickInputRef} />
                )}
            />
        </div>
    );
};
